<template>
  <group-challenge-signup-base class="invite-participants" :headline="'אתגר קבוצתי - אוכל בחוץ'"
                               :description="'האתגר הוא אתגר קבוצתי, לכן עליך לשתף את הלינק הבא עם לפחות שני חברים.'"
                               :cta-button-title="'הבא >'" :cta-button-action="nextStep">
    <template v-slot:body>
      <div class="number">2</div>
      <div class="title">הוספת חברים לאתגר</div>
      <div class="description">
        אנחנו ממליצים לך לפתוח קבוצת וואטסאפ לחברי הקבוצה שבאתגר, ככה תוכלו להיות על זה ביחד.
        <span class="bold">החברים באתגר לא חייבים להיות משתמשי רייזאפ.</span>
      </div>
      <div class="invite-buttons">
        <riseup-button class="invite-button" title="צירוף חברים לאתגר" variant="secondary" :action="shareClick"/>
        <div class="copy-text">אפשר גם לשלוח לינק</div>
        <input-copy class="input-copy" :input-content="link" @copied="linkCopied" @copyFailed="linkCopyFailed" inputDirection="ltr"/>
      </div>
    </template>
  </group-challenge-signup-base>
</template>

<script>
import BaseUI from 'base-ui';
import ShareUtils from '@/utils/share';
import EventBus from '@/event-bus/event-bus';
import TextCopiedToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/TextCopiedToaster';
import TextCopyFailedToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/TextCopyFailedToaster';
import { mapActions, mapState } from 'vuex';
import GroupChallengeSignupBase
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/GroupChallengeSignupBase';
import Segment from '@/Segment';
import {
  EATING_OUT_CHALLENGE_PROTOTYPE_V1,
} from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/constants';
import config from '@/config';

export default {
  name: 'InviteParticipants',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    InputCopy: BaseUI.InputCopy,
    GroupChallengeSignupBase,
  },
  data() {
    return {
      didShare: false,
    };
  },
  computed: {
    ...mapState('accountabilityChallenge', ['ownerParticipantId']),
    link() {
      const { elsaPublicUrl } = config.get();
      return `${elsaPublicUrl}/challenges/${this.ownerParticipantId}`;
    },
  },
  methods: {
    ...mapActions('accountabilityChallenge', ['goToChallengeDashboard']),
    nextStep() {
      this.goToChallengeDashboard();
    },
    async shareClick() {
      await ShareUtils.shareLink(
        this.link,
        'אני רוצה לשתף אותך באתגר הקבוצתי שלי בנושא אוכל בחוץ, לחץ כאן כדי לשמוע עוד ',
        {
          challengeId: this.ownerParticipantId,
          shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1,
        },
      );
      this.didShare = true;
    },
    linkCopied() {
      EventBus.$emit('open-toaster', {
        component: TextCopiedToaster,
        props: {},
      });
      this.didShare = true;
      Segment.trackUserInteraction('EatingOutChallengeUserCopiedSharableLink',
        { challengeId: this.ownerParticipantId, shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1 });
    },
    linkCopyFailed() {
      EventBus.$emit('open-toaster', {
        component: TextCopyFailedToaster,
        props: {},
      });
    },

  },
};

</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

.invite-participants {
  .number {
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    width: 32px;
    font-weight: bold;
    background-color: $riseup_light_blue;
    color: $riseup_blue;
    border-radius: 50%;
  }
  .title {
    font-weight: bold;
  }
  .description {
    .bold {
      font-weight: bold;
    }
  }
  .invite-buttons {
    margin-top: 32px;
    .invite-button {
      height: 60px;
      width: 100%;
    }
    .copy-text {
      text-align: center;
      margin: 30px 0 24px;
    }
    .input-copy {
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

</style>
